/**
 * Single rule for "this vendor is a Simples Nacional or MEI optant" in AP withholding.
 *
 * Payments to an optant carry no retention of the PIS/COFINS/CSLL block (Lei 10.833/2003,
 * art. 32, III; regulated by IN SRF 459/2004, art. 3º) nor of IRRF on services
 * (IN RFB 765/2007). MEI sits inside the Simples Nacional (LC 123/2006, art. 18-A).
 * INSS (cessão de mão de obra) and municipal ISS follow their own rules and are NOT
 * covered here.
 *
 * Vendor rows carry the regime in two places: the `optanteSimples` / `optanteMei`
 * flags (from the Simples Nacional lookup) and the `taxRegime` enum (set on the vendor
 * form or by intake). Either one is enough. Bill edits, and intake under a vendor rule, read
 * the vendor row; intake without a vendor rule passes only the regime it inferred from the
 * document. A vendor rule that applies an exempt tax wins over the exemption (vendor knowledge D7).
 */
export interface VendorSimplesSource {
  optanteSimples?: boolean | null;
  optanteMei?: boolean | null;
  taxRegime?: string | null;
}

export const SIMPLES_EXEMPT_WITHHOLDING_TAX_TYPES = ['IRRF', 'PIS', 'COFINS', 'CSLL'] as const;

export function isVendorSimplesOrMei(vendor: VendorSimplesSource | null | undefined): boolean {
  if (!vendor) return false;
  return (
    vendor.optanteMei === true ||
    vendor.optanteSimples === true ||
    vendor.taxRegime === 'SIMPLES_NACIONAL' ||
    vendor.taxRegime === 'MEI'
  );
}

export function isVendorMei(vendor: VendorSimplesSource | null | undefined): boolean {
  if (!vendor) return false;
  return vendor.optanteMei === true || vendor.taxRegime === 'MEI';
}
